const icons = {
  icon_1: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="31" cy="31" r="31" fill={backgroundColor || '#1CAEB2'} strokeWidth={0} />
      <path
        d="M44.8511 23.1711C44.7174 23.8139 44.3205 24.274 43.8827 24.7243C38.8144 29.9343 33.7524 35.1514 28.6922 40.3699C28.2923 40.7825 27.8387 41.0087 27.2791 40.8339C27.0507 40.7624 26.8167 40.624 26.6476 40.4511C24.1267 37.8705 21.6127 35.2821 19.1044 32.6878C18.247 31.8007 18.2622 30.551 19.1183 29.6575C19.4015 29.3618 19.6867 29.0674 19.9743 28.7756C20.8405 27.8976 22.0543 27.8911 22.9154 28.7736C24.4194 30.3138 25.9158 31.8612 27.4128 33.4085C27.4778 33.4761 27.5163 33.5703 27.6103 33.7211C27.732 33.5521 27.7838 33.4566 27.8557 33.3825C32.0074 29.1018 36.1604 24.8244 40.3127 20.547C41.293 19.5371 42.4614 19.5338 43.4386 20.5372C43.5786 20.6808 43.7124 20.831 43.8588 20.9674C44.3224 21.4009 44.7155 21.8812 44.8517 22.5343V23.1711H44.8511Z"
        fill="white"
      />
      <circle cx="31" cy="31" r="31" fill={backgroundColor || '#1CAEB2'} strokeWidth={0} />
      <path
        d="M29.8061 13.9746C30.0717 12.6751 31.9283 12.6751 32.1939 13.9746C33.8233 21.9466 40.0534 28.1767 48.0254 29.8061C49.3249 30.0717 49.3249 31.9283 48.0254 32.1939C40.0534 33.8233 33.8233 40.0534 32.1939 48.0254C31.9283 49.3249 30.0717 49.3249 29.8061 48.0254C28.1767 40.0534 21.9466 33.8233 13.9746 32.1939C12.6751 31.9283 12.6751 30.0717 13.9746 29.8061C21.9466 28.1767 28.1767 21.9466 29.8061 13.9746Z"
        fill="white"
      />
    </svg>
  ),
  icon_2: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 62 62" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="31" cy="31" r="31" fill={backgroundColor || '#1CAEB2'} />
      <path d="M34.6667 34.6667L23.3333 46L46 46L46 23.3333L34.6667 34.6667Z" fill="white" />
      <path d="M34.6667 34.6667L12 34.6667L34.6667 12L34.6667 34.6667Z" fill="white" />
    </svg>
  ),
  icon_3: (backgroundColor: string) => (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="31" cy="31" r="31" fill={backgroundColor || '#1CAEB2'} />
      <path
        d="M31 31C33.6259 27.8974 37.5789 25.9231 42 25.9231C46.4211 25.9231 50.3741 27.8974 53 31C50.3741 34.1026 46.4211 36.0769 42 36.0769C37.5789 36.0769 33.6259 34.1026 31 31Z"
        fill="white"
      />
      <path
        d="M31 31C34.1026 33.6259 36.0769 37.5789 36.0769 42C36.0769 46.4211 34.1026 50.3741 31 53C27.8974 50.3741 25.9231 46.4211 25.9231 42C25.9231 37.5789 27.8974 33.6259 31 31Z"
        fill="white"
      />
      <path
        d="M9 31C11.6259 27.8974 15.5789 25.9231 20 25.9231C24.4211 25.9231 28.3741 27.8974 31 31C28.3741 34.1026 24.4211 36.0769 20 36.0769C15.5789 36.0769 11.6259 34.1026 9 31Z"
        fill="white"
      />
      <path
        d="M31 9C34.1026 11.6259 36.0769 15.5789 36.0769 20C36.0769 24.4211 34.1026 28.3741 31 31C27.8974 28.3741 25.9231 24.4211 25.9231 20C25.9231 15.5789 27.8974 11.6259 31 9Z"
        fill="white"
      />
    </svg>
  )
};

type SvgIconsProps = {
  iconName: keyof typeof icons;
  sizeWidth?: string;
  sizeHeight?: string;
  backgroundColor?: string;
  className?: string;
};

const SvgIcons = ({
  iconName,
  sizeWidth = '25px',
  sizeHeight = '24px',
  backgroundColor,
  className
}: SvgIconsProps) => {
  const Svg = icons[iconName](backgroundColor || '#2EC5CE');

  return <Svg width={sizeWidth} height={sizeHeight} className={className} />;
};

export default SvgIcons;
